varying float vHeight;

const float brightness = 1.15;
const vec3 topBladeColor = vec3(0.365, 0.588, 0.369);
const float mixFactor = 0.80;
const vec3 baseColor = vec3(0.5);

void main() {
    float heightCubed = vHeight * vHeight * vHeight * vHeight;
    vec3 color = mix(baseColor, topBladeColor, mixFactor) * heightCubed * brightness;

    csm_DiffuseColor = vec4(color, 1.0);
}

